import { useId } from "react";

export const COMMON_UNITS = [
  "Piece", "Strip", "Box", "Pack", "Carton", "Bottle", "Vial", "Ampoule",
  "Tube", "Pair", "Set", "Kit", "Roll", "Dozen", "Kg", "g", "L", "ml", "Unit"
];

export default function UnitInput({ value, onChange, testId, className = "sgp-input", placeholder = "Piece / Kg / L / custom" }) {
  const generatedId = useId().replace(/:/g, "");
  const listId = `sgp-common-units-${testId || generatedId}`;
  return (
    <>
      <input
        data-testid={testId}
        list={listId}
        className={className}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
      />
      <datalist id={listId}>
        {COMMON_UNITS.map((unit) => <option key={unit} value={unit} />)}
      </datalist>
    </>
  );
}
